/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { SiteSettingInput } from './SiteSettingInput';
const PatchSettingsTenantDataParser = 
/* #__PURE__ */ parsers.object([
    ['updates', /* #__PURE__ */ codecArray(SiteSettingInput)],
]);
export class PatchSettingsTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSettingsTenantDataParser.decode(input).map(res => new PatchSettingsTenantData(res));
    }
    static unsafeDecode(input) {
        return PatchSettingsTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSettingsTenantDataParser.encode(data);
    }
    static schema() {
        return PatchSettingsTenantDataParser.schema();
    }
}
